import { Injectable } from '@angular/core';
import { ListFilters, UrlCodecs } from 'src/app/shared/ExtendedListService';
import type { GetTestListDto } from '@proxy/tests';

/** Declares which GetTestListDto keys are persisted in the URL and how. */
@Injectable()
export class TestsFilters extends ListFilters<GetTestListDto> {
  readonly schema = {
    creatorId: UrlCodecs.string,
  };
}
